import { RefObject, useEffect } from "react";

type UseClickOutside<T> = (ref: RefObject<T>, cb: Function) => void;

export const useClickOutside: UseClickOutside<any> = (ref, cb) => {
  useEffect(() => {
    const el = ref.current;
    const handleClickOutside = (event: MouseEvent) => {
      if (el && !el.contains(event.target as Node)) {
        cb();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [ref, cb]);
};
